import * as React from "react"
import { useIntl } from "react-intl"
import { LanguageSwitcher } from "@/components/LanguageSwitcher"

/** Centered card on the canvas, for login, signup, and the other signed-out forms. */
export function AuthShell({ children, betaNote = false }: { children: React.ReactNode; betaNote?: boolean }) {
  const intl = useIntl()
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-4 py-12 text-ink-body">
      <div className="w-full max-w-md rounded-xl bg-page p-8 shadow-xs ring-1 ring-ink-display/5 dark:ring-white/10">{children}</div>
      <LanguageSwitcher id="auth-language-switcher" className="mt-4 w-auto text-xs" />
      {betaNote && <p className="mt-4 text-center text-xs text-ink-muted">{intl.formatMessage({ id: "auth.beta_note" })}</p>}
    </div>
  )
}
